import { ReactNode } from "react";

export enum AdminRole {
	ADMIN = "ADMIN",
	T2F_MANAGER = "T2F_MANAGER",
	KIOSK_OWNER = "KIOSK_OWNER",
}

export type SideBarLink = {
	key: string;
	label: string;
	path: string;
	icon: ReactNode;
	active?: boolean;
	allowedRoles?: string[];
	isExternal?: boolean;
};

export type TokenPayload = {
	sub: string;
	username: string;
	role?: string;
	exp: number;
	iat: number;
	token: string;
};

export interface SearchableDataCell {
	searchTerm?: string | number;
	name: string;
	type: string;
	value: string | number | ReactNode;
	style?: string;
	onClick?: () => void;
}

export interface DataCardCell extends SearchableDataCell { }

export interface DataTableCell extends SearchableDataCell {
	onDoubleClick?: (
		event: React.MouseEvent<HTMLInputElement | HTMLTableRowElement, MouseEvent>,
		id: string
	) => void;
}

export interface DataTableRow {
	id?: string;
	data: DataTableCell[] | DataCardCell[];
	style?: string;
	onClick: (
		event: React.MouseEvent<HTMLElement, MouseEvent>,
		id: string
	) => void;
	onDoubleClick?: (
		event: React.MouseEvent<HTMLInputElement | HTMLTableRowElement, MouseEvent>,
	) => void;
}

export class AppRoutes {
	static LOGIN = "/login";
	static FORGOT_PASSWORD = "/forgot-password";
	static REGISTER = "/register";
	static LOGOUT = "/logout";
	static HOME = "/";
	static DASHBOARD = "/dashboard";
	static KIOSKS = "/kiosks";
	static KIOSK_BILLING = "/kiosk-billing";
	static OWNER_PAYOUT_REQUESTS = "/owner-payout-requests";
	static KIOSK_CONFIGURATION = "/kiosk-configuration";
	static KIOSK_PERFORMANCE = "/kiosk-performance";
	static OWNER_REPORTING_PAYOUT_SETTINGS = "/owner-reporting-payout-settings";
	static OWNER_REWARDS = "/owner-rewards";
	static SOCIAL_MEDIA_CAMPAIGN = "/social-media-campaign";
	static SUPPORT_REQUESTS = "/support-requests";
	static SITE_REQUESTS = "/site-requests";
	static KIOSK_REGISTRATIONS = "/kiosk-registrations";
	static WAITLIST_QR_MANAGEMENT = "/waitlist-qr-management";
	static CMS = "/cms";
	static REFERRALS = "/referrals";
	static USERS = "/users";
	static CAMPAIGN = "/campaigns";
	static DONATIONS = "/donations";
	static FUNDS = "/funds";
	static SHIPMENTS = "/shipments";
	static PROMOTIONS = "/promotions";
	static _401 = "/401";
	static _404 = "*";
}
